// @core/api/endpoints/document/acquire_document_lock.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AcquireDocumentLockRequest,
  DocumentLockResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Acquire document lock
 * Acquires a pessimistic editing lock on a document. Returns the lock if acquired, or information about the current lock holder if the document is already locked. Lock expires after 30 minutes of inactivity.
 */
export async function AcquireDocumentLock(
  document_id: string,
  data: AcquireDocumentLockRequest,
  options?: RequestOptions
): Promise<DocumentLockResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:document_id/lock`;
  requestPath = requestPath.replace(':document_id', encodeURIComponent(document_id));
  const requestOptions = options;
  return client.post<DocumentLockResponse>(requestPath, data, requestOptions);
}
